export default "__VITE_ASSET__895e7942__"